import React, { useState, useEffect } from "react";
import { ScrollView } from "react-native";

import moment from "moment";

import ComparisonCard from "../home/cards/reflection/ComparisonCard";
import appStyles from "../../appStyles";
import AppTheme from "../AppTheme";
import StatsCard from "../home/cards/StatsCard";
import ReflectionCard from "../home/cards/ReflectionCard";
import ReflectionViewSettingsCard from "../home/cards/reflection/ReflectionViewSettingsCard";
import { buildCards } from "../cards/CardItems";
import SnoozeOptions from "../common/SnoozeOptions";
import { hasItems } from "../../../helpers/utils";
import JournalDialog from "../common/JournalDialog";

const CardsList = {
  //comparison_card: ComparisonCard,
  stats_card: StatsCard,
  reflection: ReflectionCard,
};

export default function ReflectionInsights({
  controller,
  selectedDate,
  timeUnit,
  changeViewMode = () => {},
}) {
  const [cards, setCards] = useState(null);
  const [snoozedCardProxy, setSnoozedCardProxy] = useState(null);
  const [snoozeY, setSnoozeY] = useState(null);
  const [comparison, setComparison] = useState(null);
  const [selectedGem, setSelectedGem] = useState(null);

  // ------------------------------------- METHODS -------------------------------------
  const snoozeCard = (cardUtils, e) => {
    const y = e.clientY || e.nativeEvent?.pageY;
    setSnoozedCardProxy(cardUtils);
    setSnoozeY(y);
  };

  const onSnooze = (option) => {
    snoozedCardProxy.snoozeCard(option);
    setSnoozedCardProxy(null);
  };

  const getCompareDataFromApi = () => {
    // Fetch data for current interval
    const queryDate = moment(selectedDate)
      .add(1, timeUnit)
      .format("YYYY-MM-DD");

    const params = {
      reflectionDate: queryDate,
      time_unit: timeUnit,
      useElements: !!this.useElements,
      fullComparison: true,
    };

    controller.getApiData("comparisons", params, (comparisons) => {
      if (hasItems(comparisons)) {
        const c = comparisons[0];

        setComparison({
          ...c,
          selectedDate,
          time_unit: timeUnit,
        });
      }
    });
  };

  const initStatsCards = () => {
    const snoozedCards = controller.state.snoozed_cards || [];
    const cardItems = controller.state.cards_v2 || [];

    const filteredCards = cardItems.filter((c) => !snoozedCards[c.card_id]);

    filteredCards.forEach((c) => {
      c.selectedDate = selectedDate;
    });

    let cardsV2 = [];
    buildCards(controller, filteredCards, cardsV2, {
      allowedCardsList: CardsList,
      onSnooze: snoozeCard,
      toggleGoalJournalDialog: toggleJournalDialog,
      time_unit: timeUnit,
      fromReflection: true,
    });

    setCards(cardsV2);
  };

  const toggleJournalDialog = (gem) => {
    setSelectedGem(gem);
  };

  const onJournalComplete = () => {
    setSelectedGem(null);

    // Refresh
    getCompareDataFromApi();
  };
  // ------------------------------------- END METHODS -------------------------------------

  useEffect(() => {
    if (!selectedDate || !timeUnit) return;

    getCompareDataFromApi();
    initStatsCards();
  }, [selectedDate, timeUnit]);

  // ------------------------------------- RENDER -------------------------------------
  return (
    <>
      {snoozedCardProxy ? (
        <SnoozeOptions
          style={{ marginBottom: 16 }}
          showSnoozed={false}
          snoozeY={snoozeY}
          onSnooze={onSnooze}
          disableOverlay
        />
      ) : null}

      {/* Journal popup */}
      {selectedGem ? (
        <JournalDialog
          type={"reflection"}
          item={selectedGem}
          controller={controller}
          close={() => setSelectedGem(null)}
          onJournalComplete={onJournalComplete}
        />
      ) : null}

      <ScrollView
        contentContainerStyle={appStyles.scrollViewContent}
        style={[
          appStyles.scrollView,
          {
            marginTop: 0,
            paddingHorizontal: 0,
            backgroundColor: AppTheme.containerBg,
          },
        ]}
      >
        <ReflectionViewSettingsCard changeViewMode={changeViewMode} />

        {comparison ? (
          <ComparisonCard
            key={comparison.card_id}
            controller={controller}
            data={comparison}
            showMore={true}
            toggleGoalJournalDialog={(el) => setSelectedGem(el)}
            refreshHandler={getCompareDataFromApi}
          />
        ) : null}

        {/* Stats & Score Cards */}
        {cards}
      </ScrollView>
    </>
  );
}
